import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HelpersService } from '../../../../services';
import { CommunicationService } from '../../../../services/communication.service';
import { ConnectTextMessagePlatformComponent } from 'src/app/components/modals/connect-text-message-platform/connect-text-message-platform.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-text-message-platform-integration',
  templateUrl: './text-message-platform-integration.component.html',
  styleUrls: ['./text-message-platform-integration.component.scss'],
  providers: [MessageService],
})

export class TextMessagePlatformIntegrationComponent {
  public partner: any = {};
  public broadcastChannel = new BroadcastChannel('TEXT_MESSAGE_PLATFORM');
  textMessagingPlatforms: any[] = [];
  public win;
  public platformID: any = 0;
  public connectedPlatform: number = 0;

  public busy: boolean = true;
  public disconnectBusy: boolean = false;

  // Added for dropdown
  public storeTypes: any[] = [];
  public selectedStoreType: any;

  constructor(
    private communicationService: CommunicationService,
    private helpersService: HelpersService,
    public modalService: NgbModal,
    private confirmationService: ConfirmationService,
    public messageService: MessageService,
    private translate: TranslateService,
    private router: Router
  ) {
    // Initialize platform types for dropdown
    this.storeTypes = [];
  }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();

    this.getPartnerConfiguredStore();

    localStorage.setItem('CommunicationPartnerID', this.helpersService.getPartnerId());
    this.broadcastChannel.onmessage = (ev) => {
      if (ev.data === 'CONNECTED') {
        this.getPartnerConfiguredStore();
        localStorage.removeItem('CommunicationPartnerID');
        localStorage.removeItem('CommunicationPlatformID');
      }
      else {

      }
    };
  }

  // Added for dropdown selection
  onStoreTypeChange(event) {
    console.log('Selected platform type:', event.value);
    if (event.value === null) return;

    if (this.connectedPlatform == 1) {
      this.communicationService.saveData(this.helpersService.getPartnerId(),
        { TextPlatformSystemId: 1, Ikeono: { ShopId: event.value.code, ShopName: event.value.name, ShopNumber: event.value.number } }
      ).subscribe(res => { });
    }
  }

  getPlatforms() {
    this.textMessagingPlatforms = [];
    this.communicationService.getConfiguredTextMessagePlatforms().subscribe(res => {
      this.textMessagingPlatforms = res
        .filter((platform: any) => platform.name !== 'Coax')
        //.filter((platform: any) => platform.name !== 'Podium')// Until we can activate it
        .map((platform: any) => ({
          id: platform.id,
          name: platform.name,
          logo: platform.logoUrl,
          description: platform.description
        }));
    }, err => {

    })
  }

  configurePlatform(platformID: number) {
    var data: any = {
      "PartnerID": this.helpersService.getPartnerId(),
      "PlatformID": platformID
    }
    this.platformID = platformID;
    switch (platformID) {
      case 1:
        {
          // Ikeono
          localStorage.setItem('CommunicationPlatformID', this.platformID);
          this.communicationService.getOAuthRequest(data).subscribe(res => {
            this.win = this.launchAuthPopup(res);
          }, err => {

          })
          break;
        }
      case 2:
        {
          // Podium
          localStorage.setItem('CommunicationPlatformID', this.platformID);
          this.communicationService.getOAuthRequest(data).subscribe(res => {
            this.win = this.launchAuthPopup(res);
          }, err => {

          })
          break;
        }
      case 3: {
        // Twilio
        const modalRef = this.modalService.open(ConnectTextMessagePlatformComponent, {
          size: 'xl',
          backdrop: 'static',
        });

        modalRef.componentInstance.partner = this.partner;
        modalRef.componentInstance.selectTextMessagePlatform = 3;
        modalRef.componentInstance.modal = modalRef;

        modalRef.result.then(
          (result) => {
            this.getPartnerConfiguredStore();
          },
          (onrejected) => {
            this.getPartnerConfiguredStore();
          },
        );
        break;
      }
      case 4: {
        // Coax
        const modalRef = this.modalService.open(ConnectTextMessagePlatformComponent, {
          size: 'lg',
          backdrop: 'static',
        });

        modalRef.componentInstance.partner = this.partner;
        modalRef.componentInstance.selectTextMessagePlatform = 4;
        modalRef.componentInstance.modal = modalRef;

        modalRef.result.then(
          (result) => {
            this.getPartnerConfiguredStore();
          },
          (onrejected) => {
            this.getPartnerConfiguredStore();
          },
        );
        break;
      }
      default:
        break;
    }
  }

  launchAuthPopup(url) {
    console.log("OAuth URL:", url);
    const name = 'AuthForm_' + Date.now(); // Unique name to allow window to open again
    var w = window.open(
      url,
      name,
      'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=860,height=720',
    );
    return w;
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.parent === null) {

      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  getPartnerConfiguredStore() {
    this.busy = true; // Show loader

    this.communicationService.getConfiguredTextMessagePlatformForPartner(this.helpersService.getPartnerId()).subscribe(res => {
      this.connectedPlatform = res.textPlatformSystemId;
      if (this.connectedPlatform == 0) {
        this.getPlatforms();
        this.busy = false; // Hide loader
      }
      else {
        console.log(`test`, res);

        this.communicationService.getAccounts(this.helpersService.getPartnerId()).subscribe(accounts => {
          console.log(accounts);

          if (this.connectedPlatform == 1) {
            // Ikeono
            accounts.ikeono.forEach((account: any) => {
              this.storeTypes.push({ name: account.shopName, code: account.shopId, number: account.shopNumber });
              if (res.ikeono.shopId == account.shopId)
                this.selectedStoreType = {
                  name: account.shopName,
                  code: account.shopId,
                  number: account.shopNumber
                };
            });
          }
          else if (this.connectedPlatform == 2) {
            // Podium
            this.selectedStoreType = {
              locations: accounts.podium.locations,
              selectedLocation: accounts.podium.selectedLocation
            };
          }
          else if (this.connectedPlatform == 3) {
            // Twilio
            this.selectedStoreType = {
              accountSID: accounts.twilio.accountSID,
              authToken: accounts.twilio.authToken,
              phoneNumberSID: accounts.twilio.phoneNumberSID,
              phoneNumber: accounts.twilio.phoneNumber,
              messagingServiceSID: accounts.twilio.messagingServiceSID
            };
          }
          else if (this.connectedPlatform == 4) {
            // Coax
            this.selectedStoreType = {
              apiKey: accounts.coax.apiKey
            };
          }

          //console.log('get', this.selectedStoreType);
          this.busy = false; // Hide loader
        },
          err => {
            this.busy = false; // Hide loader
          })
      }
    }, err => {
      this.busy = false; // Hide loader
    })
  }

  removePlatform() {
    console.log('remove');
    this.confirmationService.confirm({
      key: 'text_message_integration_confirmation',
      rejectVisible: true,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.ok'),
      header: this.translate.instant(
        'bikeshop.text_message_integration.disconnect_header',
      ),
      message: this.translate.instant(
        'bikeshop.text_message_integration.disconnect_message',
      ),
      accept: () => {
        this.disconnectBusy = true;

        this.communicationService.disconnectData(this.helpersService.getPartnerId()).subscribe(res => {
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.text_message_integration.disconnected_success_message',
            ),
          });

          this.connectedPlatform = 0;
          //this.getPlatforms();
          this.disconnectBusy = false;

          // Refresh the page after everything is cleaned up
          window.location.reload(); 
        }, err => {
          this.disconnectBusy = false;
        })

      },
      reject: () => {

      },
    });
  }

}
